import { render, staticRenderFns } from "./WaybillGroupCustomerDetailView.vue?vue&type=template&id=200cd3c0&"
import script from "./WaybillGroupCustomerDetailView.vue?vue&type=script&lang=js&"
export * from "./WaybillGroupCustomerDetailView.vue?vue&type=script&lang=js&"
import style0 from "./WaybillGroupCustomerDetailView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports